(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function padSummerCountdown(value) {
    return String(value).padStart(2, '0');
  }

  function tickSummerCountdown(timer) {
    const daysOutput = timer.querySelector('[data-am-summer-countdown-days]');
    const hoursOutput = timer.querySelector('[data-am-summer-countdown-hours]');
    const minutesOutput = timer.querySelector('[data-am-summer-countdown-minutes]');
    const secondsOutput = timer.querySelector('[data-am-summer-countdown-seconds]');
    const target = new Date(timer.getAttribute('data-target'));

    if (!daysOutput || !hoursOutput || !minutesOutput || !secondsOutput || !target.getTime()) return;

    const remaining = Math.max(0, target.getTime() - Date.now());
    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    daysOutput.textContent = padSummerCountdown(days);
    hoursOutput.textContent = padSummerCountdown(hours);
    minutesOutput.textContent = padSummerCountdown(minutes);
    secondsOutput.textContent = padSummerCountdown(seconds);
  }

  document.querySelectorAll('[data-am-summer-countdown]').forEach((timer) => {
    tickSummerCountdown(timer);
    setInterval(() => tickSummerCountdown(timer), 1000);
  });

  } catch(e) { console.error(e); }
})();
})();
